import React, { useState } from "react";
import emailjs from "emailjs-com";
import { useTheme } from "../../context/ThemeContext";

const ContactForm = () => {
    const [copied, setCopied] = useState(null);

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        setCopied(text);

        setTimeout(() => {
            setCopied(null);
        }, 2000); // Remove message after 2 seconds
    };

    const { theme } = useTheme();

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs
            .send(
                "service_tuqwzoy",
                "template_8ri7ica",
                {
                    user_name: formData.name,
                    user_email: formData.email,
                    message: formData.message,
                },
                "ILTHWHVk_fAImMnLw"
            )
            .then(
                (response) => {
                    // console.log("SUCCESS!", response.status, response.text);
                    setStatus("Message sent successfully!");
                    setFormData({ name: "", email: "", message: "" });

                    // Clear the success message after 2 seconds
                    setTimeout(() => {
                        setStatus("");
                    }, 2000);
                },
                (error) => {
                    // console.log("FAILED...", error);
                    setStatus(`Error: ${error.text}. Please try again later.`);

                    // Clear the error message after 2 seconds
                    setTimeout(() => {
                        setStatus("");
                    }, 2000);
                }
            );
    };

    return (
        <>
            <div className="container mx-auto rounded-lg shadow p-8 ubuntu-regular">
                <h2 className="text-3xl font-bold text-left ">Contact Form</h2>
                <div className="flex flex-col items-center justify-center ">
                    <div className="my-5 flex flex-row gap-6">
                        {/* Electrozeus Division */}
                        <div className="relative flex flex-col items-center">
                            {/* Copy message (shown above the button) */}
                            {copied === "electrozues" && (
                                <div className="absolute -top-6 bg-yellow-500 text-white py-1 px-2 rounded-md flex items-center">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                    >
                                        <path d="M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM5.00242 8L5.00019 20H14.9998V8H5.00242ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6Z"></path>
                                    </svg>
                                    <p className="text-xs">Copied</p>
                                </div>
                            )}

                            {/* Electrozeus Button */}
                            <span
                                onClick={() => handleCopy("electrozues")}
                                className="transition-transform duration-300 hover:scale-110 cursor-pointer inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ring-gray-500/10"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="32"
                                    height="32"
                                    fill="currentColor"
                                    className="mx-1"
                                >
                                    <path d="M8.52062 13.8458C7.48059 13.8458 6.63159 12.9014 6.63159 11.7446 6.63159 10.5879 7.45936 9.64331 8.52062 9.64331 9.57123 9.64331 10.4308 10.5879 10.4096 11.7446 10.4096 12.9014 9.57123 13.8458 8.52062 13.8458ZM15.4941 13.8458C14.454 13.8458 13.604 12.9014 13.604 11.7446 13.604 10.5879 14.4328 9.64331 15.4941 9.64331 16.5447 9.64331 17.4043 10.5879 17.3831 11.7446 17.3831 12.9014 16.5553 13.8458 15.4941 13.8458ZM10.1253 4.32296 9.81655 3.76001 9.18323 3.86556C7.71915 4.10958 6.32658 4.54677 5.02544 5.14604L4.79651 5.25148 4.65507 5.46009C2.0418 9.31441 1.3258 13.1087 1.68032 16.8362L1.71897 17.2425 2.04912 17.4824C3.78851 18.7465 5.47417 19.5189 7.12727 20.0257L7.91657 20.2676 9.03013 17.5506C10.9397 18.0226 13.0592 18.0228 14.969 17.5511L16.0757 20.2683 16.8668 20.0256C18.5173 19.5193 20.2137 18.7472 21.9466 17.4811L22.2726 17.243 22.3131 16.8414C22.7491 12.5213 21.616 8.75773 19.3547 5.45652L19.2128 5.24944 18.9846 5.14504C17.6767 4.54685 16.2852 4.10981 14.8309 3.86573L14.2132 3.76207 13.8987 4.30369C13.8112 4.45445 13.7215 4.62464 13.6364 4.79687 12.5441 4.6847 11.456 4.68446 10.3726 4.79652 10.2882 4.62736 10.2025 4.4638 10.1253 4.32296ZM6.71436 16.6102C6.91235 16.7243 7.11973 16.8358 7.32557 16.9381L6.8764 18.034C5.75585 17.6259 4.61837 17.0637 3.4476 16.2557 3.22313 13.1178 3.86092 9.951 6.01196 6.68626 6.90962 6.29123 7.8535 5.98279 8.83606 5.77295 8.89631 5.89831 8.95235 6.02066 8.99839 6.12917L9.27128 6.77238 9.96259 6.67098C11.3152 6.4726 12.6772 6.47234 14.0523 6.67124L14.7424 6.77106 15.0147 6.12917C15.0621 6.01743 15.1167 5.89547 15.1743 5.77322 16.1525 5.98326 17.098 6.29212 18.0029 6.68812 19.8781 9.50857 20.8241 12.6544 20.5486 16.2552 19.3837 17.0625 18.2422 17.6249 17.1193 18.0335L16.6735 16.939C16.8799 16.8365 17.0879 16.7246 17.2865 16.6102 17.7763 16.328 18.3039 15.976 18.6402 15.6397L17.3606 14.3602C17.1969 14.5239 16.837 14.7808 16.3831 15.0423 15.9388 15.2983 15.498 15.5052 15.2164 15.5983 13.2126 16.2608 10.7883 16.2608 8.78443 15.5983 8.50285 15.5052 8.06205 15.2983 7.61772 15.0423 7.16383 14.7808 6.80392 14.5239 6.64017 14.3602L5.36065 15.6397C5.6969 15.976 6.2245 16.328 6.71436 16.6102Z"></path>
                                </svg>
                                <p className="mx-1">electrozues</p>
                            </span>
                        </div>

                        {/* Email Division */}
                        <div className="relative flex flex-col items-center">
                            {/* Copy message (shown above the button) */}
                            {copied === "prathamreet@gmail.com" && (
                                <div className="absolute -top-6 bg-yellow-500 text-white py-1 px-2 rounded-md flex items-center">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                    >
                                        <path d="M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM5.00242 8L5.00019 20H14.9998V8H5.00242ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6Z"></path>
                                    </svg>
                                    <p className="text-xs">Copied</p>
                                </div>
                            )}

                            {/* Email Button */}
                            <span
                                onClick={() =>
                                    handleCopy("prathamreet@gmail.com")
                                }
                                className="transition-transform duration-300 hover:scale-110 cursor-pointer inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ring-gray-500/10"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="32"
                                    height="32"
                                    fill="currentColor"
                                >
                                    <path d="M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM19.2382 8.66458L12 13.2005L4.76185 8.66458L4 10.0835L12 15.3177L20 10.0835L19.2382 8.66458Z"></path>
                                </svg>
                                <p className="mx-1">prathamreet@gmail.com</p>
                            </span>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit} className="w-full max-w-md">
                        <div className="mb-4">
                            <input
                                type="text"
                                name="name"
                                placeholder="Your Name"
                                value={formData.name}
                                onChange={handleChange}
                                className={`w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-yellow-500 ${
                                    theme === "dark" ? "bg-black" : "bg-white"
                                } `}
                                required
                            />
                        </div>
                        <div className="mb-4">
                            <input
                                type="email"
                                name="email"
                                placeholder="Your Email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-yellow-500 ${
                                    theme === "dark" ? "bg-black" : "bg-white"
                                } `}
                            />
                        </div>
                        <div className="mb-4">
                            <textarea
                                name="message"
                                placeholder="Your thoughts or feedbacks are much more appreciated!  Feel free to reach me out, I don't bite"
                                value={formData.message}
                                onChange={handleChange}
                                className={`w-full p-2 border border-gray-300 rounded h-32 focus:outline-none focus:ring-2 focus:ring-yellow-500 ${
                                    theme === "dark" ? "bg-black" : "bg-white"
                                } `}
                                required
                            />
                        </div>
                        <div className="mb-4 text-center">
                            {status && (
                                <div
                                    className={`text-white px-4 py-2 ${
                                        status.startsWith("Message sent")
                                            ? "bg-green-500"
                                            : "bg-red-500"
                                    } rounded`}
                                >
                                    {status}
                                </div>
                            )}
                        </div>
                        <div className="text-center">
                            <button
                                type="submit"
                                className="bg-yellow-500  px-4 py-2 rounded hover:bg-yellow-800 hover:scale-110 transition duration-300"
                            >
                                Send Message
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ContactForm;
